/*! md-authjs - 0.0.17 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mdauth", [], factory);
	else if(typeof exports === 'object')
		exports["mdauth"] = factory();
	else
		root["mdauth"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ticket = __webpack_require__(1);
	
	var _ticket2 = _interopRequireDefault(_ticket);
	
	var _info = __webpack_require__(2);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _handler = __webpack_require__(3);
	
	var _handler2 = _interopRequireDefault(_handler);
	
	var _filter = __webpack_require__(4);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// auth token expires in 1h
	// php session expires in 24'
	/* global location */
	/* eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	var TIME_BEFORE_EXPIRE = 40 * 60 * 1000; // ~ each 20', before than php session
	var DEBUG = false;
	// eslint-disable-next-line arrow-parens
	var log = function log(msg) {
	  if (DEBUG) {
	    console.log(msg);
	  }
	};
	// eslint-disable-next-line arrow-parens
	
	exports.default = function (options) {
	  var config = options.config;
	  var authInfo = options.authInfo || new _info2.default();
	  var authTicket = options.authTicket || new _ticket2.default({ config: config });
	  var authHandler = options.authHandler || new _handler2.default(config, log);
	  var authFilter = options.authFilter || new _filter2.default(authInfo, authHandler);
	  var getCompanyId = options.getCompanyId || function () {
	    return location.search.split('company_id=')[1];
	  };
	  DEBUG = options.DEBUG || false;
	
	  return {
	    timeout: null,
	    login: function login(callback) {
	      var self = this;
	      var companyId = getCompanyId();
	      authInfo.initFromLocalStorage();
	      if (!authInfo.isValid() || authInfo.expiresInLessThan(TIME_BEFORE_EXPIRE) || companyId) {
	        // eslint-disable-next-line arrow-parens
	        return this.newLogin(function (isLogged) {
	          self.afterLogin(isLogged, callback);
	        }, companyId);
	      }
	      log('auth: login from localStorage...');
	      return this.afterLogin(true, callback);
	    },
	    newLogin: function newLogin(callback, companyId) {
	      log('auth: new login, companyId=' + companyId);
	      // eslint-disable-next-line arrow-parens
	      var callbackOk = function callbackOk(response) {
	        log('auth: new login callbackOk, result: ' + response.result);
	        authInfo.init(response.result);
	        log('auth: new login saving authInfo');
	        authInfo.save();
	        callback(true);
	      };
	      // eslint-disable-next-line arrow-parens
	      var callbackError = function callbackError(err) {
	        log('auth: new login callbackError, err: ' + err);
	        callback(false);
	        authInfo.clear();
	        authHandler.handle(err.status);
	      };
	      authTicket.get(callbackOk, callbackError, companyId);
	    },
	    afterLogin: function afterLogin(isLogged, callback) {
	      this.clearTimeout();
	      if (isLogged) {
	        authFilter.init();
	        this.setNewTimeout();
	      }
	      if (callback) {
	        callback(isLogged);
	      }
	    },
	    setNewTimeout: function setNewTimeout() {
	      var self = this;
	      var refreshTime = authInfo.getTimeToExpire() - TIME_BEFORE_EXPIRE;
	      var companyId = authInfo.getCompanyId();
	      log('auth: refreshing in ' + refreshTime / 60000);
	      this.timeout = setTimeout(function () {
	        // eslint-disable-next-line arrow-parens
	        self.newLogin(function (isLogged) {
	          self.afterLogin(isLogged);
	        }, companyId);
	      }, refreshTime);
	    },
	    clearTimeout: function (_clearTimeout) {
	      function clearTimeout() {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function () {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	    }),
	    getAuthInfo: function getAuthInfo() {
	      return authInfo;
	    },
	    setHomeConfig: function setHomeConfig(home) {
	      config.home = home;
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* global $ */
	// eslint-disable-next-line arrow-parens
	exports.default = function (options) {
	  var jQuery = options.jQuery || $;
	  return {
	    get: function get(callbackOk, callbackError, companyId) {
	      jQuery.ajax({
	        method: 'get',
	        dataType: 'json',
	        // Ensure this in all cases and jquery versions.
	        accepts: { json: 'application/json' },
	        headers: {
	          Accept: 'application/json'
	        },
	        url: options.config.authHost + (companyId ? '?company_id=' + companyId : ''),
	        xhrFields: {
	          withCredentials: true
	        },
	        crossDomain: true,
	        // eslint-disable-next-line arrow-parens
	        success: function success(response) {
	          if (callbackOk) {
	            callbackOk(response);
	          }
	        },
	        // eslint-disable-next-line arrow-parens
	        error: function error(err) {
	          if (callbackError) {
	            callbackError(err);
	          }
	        }
	      });
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global window */
	var authInfo = void 0;
	// eslint-disable-next-line arrow-parens
	var _init = function _init(data) {
	  authInfo = {};
	  authInfo.access_token = data.access_token;
	  authInfo.expires_in = data.expires_in; // seconds
	  authInfo.user_name = data.user_name;
	  authInfo.group_id = data.group_id;
	  authInfo.rol_id = data.rol_id;
	  authInfo.user_id = data.user_id;
	  authInfo.company_id = data.company_id;
	  authInfo.company_name = data.company_name;
	  authInfo.time_zone = data.time_zone;
	  authInfo.currency = data.currency;
	  authInfo.companies = data.companies;
	  authInfo.companiesByGroup = data.companiesByGroup;
	  authInfo.creation_time = new Date().getTime(); // ms
	  authInfo.entrypoint = data.entrypoint;
	};
	var now = function now() {
	  return new Date().getTime();
	};
	var LOCAL_STORAGE_KEY = 'authInfo';
	var DEFAULT_TIMEZONE = 'Europe/Madrid';
	var DEFAULT_CURRENCY = {
	  iso: 'EUR',
	  simbol: '\u20AC'
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var ls = options.localStorage || window.localStorage;
	  return {
	    localStorageKey: LOCAL_STORAGE_KEY,
	    get: function get() {
	      return authInfo;
	    },
	    init: function init(data) {
	      _init(data);
	    },
	    initFromLocalStorage: function initFromLocalStorage() {
	      authInfo = JSON.parse(ls.getItem(LOCAL_STORAGE_KEY) || '{}');
	    },
	    clear: function clear() {
	      authInfo = {};
	      ls.removeItem(LOCAL_STORAGE_KEY);
	    },
	    save: function save() {
	      ls.setItem(LOCAL_STORAGE_KEY, JSON.stringify(authInfo));
	    },
	    getAccessToken: function getAccessToken() {
	      return authInfo.access_token ? authInfo.access_token : '';
	    },
	    getUserName: function getUserName() {
	      return authInfo.user_name ? authInfo.user_name : '';
	    },
	    getEntrypoint: function getEntrypoint() {
	      return authInfo.entrypoint ? authInfo.entrypoint : null;
	    },
	    getRolId: function getRolId() {
	      return authInfo.rol_id ? authInfo.rol_id : '';
	    },
	    getUserId: function getUserId() {
	      return authInfo.user_id ? authInfo.user_id : '';
	    },
	    getGroupId: function getGroupId() {
	      return authInfo.group_id ? authInfo.group_id : '';
	    },
	    getCompanyId: function getCompanyId() {
	      return authInfo.company_id ? authInfo.company_id : '';
	    },
	    setCompanyId: function setCompanyId(companyId) {
	      return authInfo.company_id = companyId;
	    },
	    getCompanyName: function getCompanyName() {
	      return authInfo.company_name ? authInfo.company_name : '';
	    },
	    setCompanyName: function setCompanyName(companyName) {
	      return authInfo.company_name = companyName;
	    },
	    getTimeZone: function getTimeZone() {
	      return authInfo.time_zone ? authInfo.time_zone : DEFAULT_TIMEZONE;
	    },
	    getCurrency: function getCurrency() {
	      return authInfo.currency ? authInfo.currency : DEFAULT_CURRENCY;
	    },
	    getCompanies: function getCompanies() {
	      return authInfo.companies ? authInfo.companies : [];
	    },
	    getGroupCompanies: function getGroupCompanies() {
	      return authInfo.companiesByGroup ? authInfo.companiesByGroup : [];
	    },
	    getCreationTime: function getCreationTime() {
	      return authInfo.creation_time;
	    },
	    getExpirationTime: function getExpirationTime() {
	      // eslint-disable-next-line no-mixed-operators
	      return authInfo.creation_time + authInfo.expires_in * 1000;
	    },
	    isExpired: function isExpired() {
	      return now() >= this.getExpirationTime();
	    },
	    isValid: function isValid() {
	      return authInfo && authInfo.access_token && !this.isExpired();
	    },
	    getTimeToExpire: function getTimeToExpire() {
	      return this.getExpirationTime() - now();
	    },
	    expiresInLessThan: function expiresInLessThan(ms) {
	      var timeToExpire = this.getTimeToExpire();
	      return timeToExpire > 0 && ms >= timeToExpire;
	    },
	    isSuperAdmin: function isSuperAdmin() {
	      return authInfo && (authInfo.rol_id === 'admin_mdirector' || authInfo.rol_id === 'admin_mdirector_sa');
	    },
	    isAdminFreemium: function isAdminFreemium() {
	      return authInfo && authInfo.rol_id === 'adm_mdirector_newfree';
	    },
	    isAdmin: function isAdmin() {
	      return authInfo && authInfo.rol_id === 'adm_mdirector';
	    },
	    isAdm: function isAdm() {
	      return this.isAdmin() || this.isAdminFreemium();
	    },
	    setCompanyData: function setCompanyData(companyId) {
	      var found = this.getGroupCompanies().find(function (cmp) {
	        return cmp.id === companyId || !companyId;
	      });
	      if (found !== undefined) {
	        this.setCompanyId(found.id);
	        this.setCompanyName(found.name);
	        this.save();
	      }
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* global window */
	exports.default = function (config, log) {
	  return {
	    handle: function handle(status) {
	      switch (status) {
	        case 401:
	          this.redirect(config.loginUrl);
	          break;
	
	        case 403:
	          this.disconnectAlert(config.home, config.i18n.auth403title, config.i18n.auth403message);
	          break;
	
	        case 500:
	          this.disconnectAlert(config.home, config.i18n.auth500title, config.i18n.auth500message);
	          break;
	        default:
	          log('Unknown error code received: ', status, ' - doing nothing');
	      }
	    },
	    disconnectAlert: function disconnectAlert(redirectUrl, title, message) {
	      log('Disconnect alert: ', redirectUrl, title, message);
	
	      var fullMessage = 'Unexpected error ocurred. Disconnected';
	      if (title && message && title !== 'undefined' && message !== 'undefined') {
	        fullMessage = title + '\n\n' + message;
	      }
	      // eslint-disable-next-line no-undef, no-alert
	      alert(fullMessage);
	      this.redirect(redirectUrl);
	    },
	    redirect: function redirect(redirectUrl) {
	      // eslint-disable-next-line no-undef
	      top.location.href = redirectUrl;
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* global $ */
	/* global document */
	exports.default = function (authInfo, authHandler) {
	  return {
	    init: function init() {
	      $.ajaxPrefilter(function (options, originalOptions, xhr) {
	        xhr.setRequestHeader('Authorization', 'Bearer ' + authInfo.getAccessToken());
	      });
	      $(document).ajaxError(function (event, xhr) {
	        authHandler.handle(xhr.status);
	      });
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** mdauth.js
 **/